export const loadWithDelay = (p1, delay = 1000) => async () => {
  await new Promise(resolve => setTimeout(resolve, delay))
  return await p1
}
